module.exports = __webpack_public_path__ + "static/logo2-6af3355e48cf2648604477cc11549af1.png";